import { Pane, Plate } from "@micropod/ui";
import { Component, type ErrorInfo, type ReactNode } from "react";

/**
 * One thrown render must not be a white screen.
 *
 * An agent mid-conversation loses everything otherwise, with nothing to act on and nothing
 * to tell support. This says what happened, offers the one action that usually works, and
 * keeps the shell frame so the app still looks like itself.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  override state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("render failed", error, info.componentStack);
  }

  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <Plate>
        <Pane kind="auth">
          <div className="auth-form">
            <h1 className="signin-title">Something broke on this screen</h1>
            <p className="signin-sub">
              Your messages are safe — this is the display, not your data. Reloading usually clears
              it.
            </p>
            <button type="button" className="btn primary" onClick={() => window.location.reload()}>
              Reload
            </button>
            <p className="probe-code" style={{ paddingInlineStart: 0, marginBlockStart: 18 }}>
              {this.state.error.message}
            </p>
          </div>
        </Pane>
      </Plate>
    );
  }
}
